import React from 'react';
import { string } from 'prop-types';

export const PurchaseIcon = ({
  spotFillColor = 'none',
  spotHeight = '61',
  spotViewBox = '0 0 56 61',
  spotWidth = '56',
} = {}) => (
  <div data-testid={'purchase-icon'} className={'flex-container'}>
    <svg
      width={spotWidth}
      height={spotHeight}
      viewBox={spotViewBox}
      fill={spotFillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1818 22.3293C11.4048 20.3017 13.1179 18.7667 15.1578 18.7667H40.8429C42.8827 18.7667 44.5958 20.3017 44.8189 22.3293L48.0456 51.6626C48.306 54.0306 46.4518 56.1 44.0695 56.1H11.9311C9.54884 56.1 7.69463 54.0306 7.95511 51.6626L11.1818 22.3293Z"
        fill="#56CCFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7071 14.3578C22.6514 15.4059 21.9338 16.9931 21.9338 19.14V24.3666H19.1338V19.14C19.1338 16.3383 20.0877 14.0056 21.7344 12.3708C23.3744 10.7425 25.6083 9.89996 28.0005 9.89996C30.3926 9.89996 32.6265 10.7425 34.2665 12.3708C35.9132 14.0056 36.8671 16.3383 36.8671 19.14V24.3666H34.0671V19.14C34.0671 16.9931 33.3495 15.4059 32.2938 14.3578C31.2315 13.3032 29.7321 12.7 28.0005 12.7C26.2689 12.7 24.7694 13.3032 23.7071 14.3578Z"
        fill="#1040C1"
      />
      <path
        d="M20.5335 27.1667C21.8222 27.1667 22.8669 26.122 22.8669 24.8333C22.8669 23.5447 21.8222 22.5 20.5335 22.5C19.2449 22.5 18.2002 23.5447 18.2002 24.8333C18.2002 26.122 19.2449 27.1667 20.5335 27.1667Z"
        fill="#1040C1"
      />
      <path
        d="M35.4671 27.1667C36.7558 27.1667 37.8004 26.122 37.8004 24.8333C37.8004 23.5447 36.7558 22.5 35.4671 22.5C34.1785 22.5 33.1338 23.5447 33.1338 24.8333C33.1338 26.122 34.1785 27.1667 35.4671 27.1667Z"
        fill="#1040C1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.6244 14.2646C42.6443 14.3174 42.6788 14.3626 42.7232 14.3945C42.7677 14.4263 42.8201 14.4433 42.8738 14.4433C42.9275 14.4433 42.9799 14.4263 43.0244 14.3945C43.0689 14.3626 43.1033 14.3174 43.1232 14.2646L44.7731 9.44416C44.7864 9.40601 44.8069 9.37109 44.8333 9.34145C44.8597 9.31182 44.8913 9.28808 44.9265 9.27164L49.502 7.49567C49.5519 7.47459 49.5946 7.43818 49.6247 7.39115C49.6548 7.34411 49.6709 7.28861 49.6709 7.23181C49.6709 7.17501 49.6548 7.11951 49.6247 7.07247C49.5946 7.02544 49.5519 6.98903 49.502 6.96795L44.9265 5.18184C44.8907 5.16945 44.8581 5.14828 44.8315 5.12007C44.8048 5.09186 44.7848 5.05739 44.7731 5.01947L43.0849 0.178691C43.0649 0.125946 43.0305 0.0807224 42.9861 0.0488706C42.9416 0.0170187 42.8891 0 42.8354 0C42.7818 0 42.7293 0.0170187 42.6848 0.0488706C42.6404 0.0807224 42.606 0.125946 42.586 0.178691L40.9074 5.01947C40.8948 5.05853 40.8733 5.09373 40.8449 5.12202C40.8165 5.15032 40.782 5.17086 40.7444 5.18184L36.1689 6.96795C36.119 6.98904 36.0763 7.02544 36.0462 7.07248C36.0161 7.11951 36 7.17501 36 7.23181C36 7.28862 36.0161 7.34412 36.0462 7.39115C36.0763 7.43818 36.119 7.47459 36.1689 7.49567L40.706 9.25134C40.7432 9.26608 40.7771 9.28912 40.8052 9.31888C40.8333 9.34865 40.8551 9.38445 40.8691 9.42387L42.6244 14.2646ZM53.3418 16.6788C54.8099 16.6788 56 17.87 56 19.3394C56 20.8088 54.8099 22 53.3418 22C51.8737 22 50.6835 20.8088 50.6835 19.3394C50.6835 17.87 51.8737 16.6788 53.3418 16.6788Z"
        fill="#FED13C"
      />
    </svg>
  </div>
);

PurchaseIcon.propTypes = {
  spotFillColor: string,
  spotHeight: string,
  spotViewBox: string,
  spotWidth: string,
};
